<div fxFlex fxLayout="column">
  <div class="iot-filter-engine sticky" fxLayout="column">
    <div class="mv-toolbar">
      <div class="mv-toolbar-row" fxLayout="row" fxLayoutAlign="start stretch" fxLayoutGap="2px">
        <div class="mv-toolbar-col" fxFlex="40" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
          <span class="mv-toolbar-total" translate [translateParams]="{count: paginator.length}">DEVICES_COUNT</span>
          <mat-progress-spinner *ngIf="loading" mode="indeterminate" [diameter]="20" color="accent"></mat-progress-spinner>
        </div>
        <div class="mv-toolbar-col" fxFlex="35" fxLayoutGap="10px" fxLayoutAlign="start center">
        </div>
        <div class="mv-toolbar-col" fxFlex="25" fxLayout="row" fxLayoutAlign="end stretch">
          <div class="app-round-button">
            <button
              mat-icon-button
              [matTooltip]="'MV_TOOLBAR.TOOLTIP.CLEAR_APPLIED_FILTERS' | translate"
              matTooltipClass="regular-tooltip"
              (click)="clearFilter()"
              *ngIf="filters.length"
            >
              <mat-icon>delete_sweep</mat-icon>
            </button>
          </div>
          <div class="app-round-button" fxLayout="row" fxLayoutAlign="center center">
            <button
              mat-icon-button
              [ngClass]="{ 'filter-open': filterOpened, 'reverse-accent-button regular-round-button': !filterOpened }"
              [matTooltip]="'MV_TOOLBAR.TOOLTIP.SHOW_FILTER_ENGINE' | translate"
              matTooltipClass="regular-tooltip"
              (click)="showFilter()"
            >
              <mat-icon>filter_list</mat-icon>
            </button>
          </div>
          <div class="app-round-button">
            <button mat-icon-button [matTooltip]="'MV_TOOLBAR.TOOLTIP.REFRESH_MV' | translate" matTooltipClass="regular-tooltip" (click)="getDevices()">
              <mat-icon>refresh</mat-icon>
            </button>
          </div>
        </div>
      </div>
    </div>

    <mat-expansion-panel [expanded]="filterOpened">
      <div class="filter-engine-row" fxLayout="row" fxLayout.lt-lg="column" fxLayoutAlign="space-between stretch">
        <div class="filter-engine-col" fxLayout="column" fxLayout.lt-md="column" fxLayoutAlign="start stretch" fxLayoutGap="10px">
          <div class="filter-engine-edition" fxLayout="row" fxLayout.lt-md="column" fxLayoutAlign="start center" fxLayoutGap="10px">
            <div class="filter-engine-title" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
              <mat-icon>filter_list</mat-icon>
              <span>{{ 'FILTER_ENGINE.TITLE' | translate }}</span>
              <div class="filter-engine-form" fxLayout="row" fxLayoutAlign="start center">
                <button class="filter-engine-menu" mat-button type="button" [matMenuTriggerFor]="filterCriteria">
                  <span>{{ filterCriteriaButtonTitle | translate | uppercase }}</span>
                  <mat-icon>arrow_drop_down</mat-icon>
                </button>
                <mat-menu #filterCriteria="matMenu">
                  <ng-container *ngFor="let category of filterCategories">
                    <button mat-menu-item [matMenuTriggerFor]="subMenu">{{ category.label | translate | uppercase }}</button>
                    <mat-menu #subMenu="matMenu">
                      <button mat-menu-item (click)="addField(option)" *ngFor="let option of category.options">{{ option.label | translate | uppercase }}</button>
                    </mat-menu>
                  </ng-container>
                </mat-menu>
                <span class="filter-engine-field"><ng-template appFilterEngine></ng-template></span>
              </div>
            </div>
          </div>
          <mat-chip-list class="filter-engine-selected" fxLayout="row wrap" fxLayoutAlign="start center" *ngIf="filters.length !== 0">
            <ng-container *ngFor="let filter of filters">
              <mat-chip class="chip" disableRipple="true">
              <span class="chip-text">
                <span class="chip-category">{{ filter.criteriaLabel | translate }}</span> :
                <span *ngIf="filter.dateLabel">{{ filter.dateLabel | dateFormat | translate }}</span>
                <span *ngIf="!filter.dateLabel">{{ filter.label | translate }}</span>
              </span>
                <mat-icon class="chip-button" (click)="onDeletePreFilter(filter)">close</mat-icon>
              </mat-chip>
            </ng-container>
          </mat-chip-list>
        </div>
      </div>
    </mat-expansion-panel>

    <mat-chip-list class="filter-engine-applied" *ngIf="!filterOpened && filters.length">
      <ng-container *ngFor="let filter of filters">
        <mat-chip class="chip" disableRipple="true">
              <span class="chip-text">
                <span class="chip-category">{{ filter.criteriaLabel | translate }}</span> :
                <span *ngIf="filter.dateLabel">{{ filter.dateLabel | dateFormat | translate }}</span>
                <span *ngIf="!filter.dateLabel">{{ filter.label | translate }}</span>
              </span>
        </mat-chip>
      </ng-container>
    </mat-chip-list>
  </div>
  <div fxLayout="row" fxFlex class="master-view-engine-container">
    <div class="table-container">
      <table mat-table matSort multiTemplateDataRows [dataSource]="dataSource" (matSortChange)="sortChange($event)">
        <ng-container matColumnDef="name">
          <th mat-header-cell mat-sort-header *matHeaderCellDef [fxLayoutAlign]="'start center'" [fxFlex]="'14%'">{{"DEVICES.DEVICE" | translate}}</th>
          <td mat-cell *matCellDef="let element" [fxLayoutAlign]="'start center'" [fxFlex]="'14%'">
            <span class="basic-cell" [matTooltip]="element.name" matTooltipPosition="above" matTooltipClass="regular-tooltip">{{element.name}}</span>
          </td>
        </ng-container>
        <ng-container matColumnDef="identifier">
          <th mat-header-cell mat-sort-header *matHeaderCellDef [fxLayoutAlign]="'start center'" [fxFlex]="'14%'">{{"DEVICES.DEVICE_IDENTIFIER" | translate}}</th>
          <td mat-cell *matCellDef="let element" [fxLayoutAlign]="'start center'" [fxFlex]="'14%'">
            <span class="basic-cell" [matTooltip]="element.identifier" matTooltipPosition="above" matTooltipClass="regular-tooltip">{{element.identifier}}</span>
          </td>
        </ng-container>
        <ng-container matColumnDef="model">
          <th mat-header-cell mat-sort-header *matHeaderCellDef [fxLayoutAlign]="'start center'" [fxFlex]="'7%'">{{"DEVICES.MODEL" | translate}}</th>
          <td mat-cell *matCellDef="let element" [fxLayoutAlign]="'start center'" [fxFlex]="'7%'">
            <span class="basic-cell" [matTooltip]="element.model" matTooltipPosition="above" matTooltipClass="regular-tooltip">{{element.model}}</span>
          </td>
        </ng-container>
        <ng-container matColumnDef="endPoint">
          <th mat-header-cell mat-sort-header *matHeaderCellDef [fxLayoutAlign]="'start center'" [fxFlex]="'9%'">{{"DEVICES.ENDPOINT" | translate}}</th>
          <td mat-cell *matCellDef="let element" [fxLayoutAlign]="'start center'" [fxFlex]="'9%'">
            <span class="basic-cell" [matTooltip]="element.endPoint" matTooltipPosition="above" matTooltipClass="regular-tooltip">{{element.endPoint}}</span>
          </td>
        </ng-container>
        <ng-container matColumnDef="description">
          <th mat-header-cell mat-sort-header *matHeaderCellDef [fxLayoutAlign]="'start center'" [fxFlex]="'19%'">{{"DEVICES.DESCRIPTION" | translate}}</th>
          <td mat-cell *matCellDef="let element" [fxLayoutAlign]="'start center'" [fxFlex]="'19%'">
            <span class="basic-cell" [matTooltip]="element.description" matTooltipPosition="above" matTooltipClass="regular-tooltip">{{element.description}}</span>
          </td>
        </ng-container>
        <ng-container matColumnDef="lastCallDate">
          <th mat-header-cell mat-sort-header *matHeaderCellDef [fxLayoutAlign]="'center center'" [fxFlex]="'14%'">{{"DEVICES.LAST_CALL" | translate}}</th>
          <td mat-cell *matCellDef="let element" [fxLayoutAlign]="'center center'" [fxFlex]="'14%'">
            <span class="basic-cell" [matTooltip]="element.lastCallDate | dateFormat" matTooltipPosition="above" matTooltipClass="regular-tooltip">
              {{element.lastCallDate | dateFormat}}
            </span>
          </td>
        </ng-container>
        <ng-container matColumnDef="lastReadingRequestDate">
          <th mat-header-cell mat-sort-header *matHeaderCellDef [fxLayoutAlign]="'center center'" [fxFlex]="'14%'">{{"DEVICES.LAST_READING_REQUEST" | translate}}</th>
          <td mat-cell *matCellDef="let element" [fxLayoutAlign]="'center center'" [fxFlex]="'14%'">
            <span class="basic-cell" [matTooltip]="element.lastReadingRequestDate | dateFormat" matTooltipPosition="above" matTooltipClass="regular-tooltip">
              {{element.lastReadingRequestDate | dateFormat}}
            </span>
          </td>
        </ng-container>
        <ng-container matColumnDef="lastConfigurationSendingDate">
          <th mat-header-cell mat-sort-header *matHeaderCellDef [fxLayoutAlign]="'center center'" [fxFlex]="'14%'">{{"DEVICES.LAST_CONFIGURATION_SENT" | translate}}</th>
          <td mat-cell *matCellDef="let element" [fxLayoutAlign]="'center center'" [fxFlex]="'14%'">
            <span class="basic-cell" [matTooltip]="element.lastConfigurationSendingDate | dateFormat" matTooltipPosition="above" matTooltipClass="regular-tooltip">
              {{element.lastConfigurationSendingDate | dateFormat}}
            </span>
          </td>
        </ng-container>
        <ng-container matColumnDef="sendingStatus">
          <th mat-header-cell mat-sort-header *matHeaderCellDef [fxLayoutAlign]="'center center'" [fxFlex]="'9%'">{{"DEVICES.SENDING_STATUS" | translate}}</th>
          <td mat-cell *matCellDef="let element" [fxLayoutAlign]="'center center'" [fxFlex]="'9%'">
            <div class="status-loading" *ngIf="(loading && element.sendingStatus === SendingStatus.Undefined) || element.loading">
              <mat-progress-spinner
                  [diameter]=20
                  [mode]="'indeterminate'"
                  [color]="'accent'">
              </mat-progress-spinner>
            </div>
            <div *ngIf="element.connector && !element.loading && !(loading && element.sendingStatus === SendingStatus.Undefined)" class="dot" [style.background-color]="element.sendingStatus"></div>
          </td>
        </ng-container>
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef [fxLayoutAlign]="'center center'" [fxFlex]="'1%'"></th>
          <td mat-cell *matCellDef="let element" [fxLayoutAlign]="'center center'" [fxFlex]="'1%'">
            <div class="app-round-button-mv">
              <button
                mat-icon-button
                [matMenuTriggerFor]="menu"
                (click)="$event.stopPropagation()">
                <mat-icon>more_vert</mat-icon>
              </button>
              <mat-menu #menu="matMenu">
                <!--<button mat-menu-item [disabled]="element.sendingStatus === SendingStatus.Undefined || element.sendingStatus === SendingStatus.Unknown" (click)="configure(element.id)">
                  <span translate>DEVICES.CONFIGURE</span>
                </button>-->
                <button mat-menu-item [disabled]="!element.canRequestConfiguration" (click)="requestConfiguration(element.id)">
                  <span translate>DEVICES.GET_CONFIGURATION</span>
                </button>
              </mat-menu>
            </div>
          </td>
      </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns" class="table-row-header"></tr>
        <tr
          mat-row
          *matRowDef="let row; columns: displayedColumns"
          class="table-row-content"
          (click)="configure(row.id)"
        ></tr>
      </table>

      <mat-paginator [pageSizeOptions]="[10, 25]"  (page)="getDevices()" showFirstLastButtons></mat-paginator>
    </div>
  </div>
</div>


